import { Component, OnInit } from '@angular/core';
import { FeeMasterServiceService } from '../../service/fee-master-service.service';
import { HttpClient } from '@angular/common/http';
import { debug } from 'util';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisaprocessingService } from 'src/app/service/visaProcessingService';
import { ClosedAPPComponent } from '../../closed-app/closed-app.component';
import { Newappservice } from '../../service/Newapplication_Service';

declare var $: any;
@Component({
  selector: 'app-fee-master',
  templateUrl: './fee-master.component.html',
  styleUrls: ['./fee-master.component.css'],
  providers: [FeeMasterServiceService]
})
export class FeeMasterComponent implements OnInit {
  AllFeeMasterdata: any = [];
  getFeeMaster: any = {};
  getallCountry: any = [];
  getVisaOffices: any = [];
  err: any = {};
  editfeeMaster: any = {};
  visaUpdateModel: any = [];
  deleteData: any = [];
  visaFeeMasterObj: any = {};
  visObj: any = {};
  visaFees: string = '';
  brancharr = [];
  editFeeMasterObj: any = {};
  editfee: any;
  edit_CountryCode: string = '';
  selectedCountryCode: any;
  UpdateFeeMasterObj: any = [];
  registerForm: FormGroup;
  submitted = false;
  visaTypeData: any = {};
  visatypeArray: any = [];
  vendorArray: any = [];
  serviceCharges: any;
  VisaFeeObject: {};
  newProccessingDays: any = {};
  visatype: any;
  EntriesArray: any = [];
  entrieslength: number = 0;
  ProcessingOptionArray: any = [];
  Fk_ProcessOptionId: any;
  ProcessingOptionlength: number = 0;
  FeeMasterarray: any = [];
  // -- Pagination --
  paginationSize = 10;
  page: number = 1;
  pageShow = 0;
  totalNoofpages: number = 0;
  selectedIndex: number = 0;
  totalcount: any;
  PageSizeArray: number[];
  countryarray: any = [];
  searchString: string = '';
  SearchKeyWord: string = '';
  searchStringcache: number = 0;
  fk_Countryid:any=0;
  visatypeid:any=0;
  Searchwithid:any=0;
  searchtype:string="";
  autolist:any=[];
  vendorid:any=0;
  constructor(private _service: FeeMasterServiceService, private _http: HttpClient, private toastr: ToastrService,
    private _visaprocessing: VisaprocessingService, public _newappService: Newappservice ) { }

  ngOnInit() {
    this.newProccessingDays.fK_CountryMasterId = null;
     this.PageSizeArray = this._newappService.PageSizeArray;
    this.clearmodal();
    this.GetCountry();
    this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
  }
  // Setting NULL for dropdown
  clearmodal = function () {
    this.newProccessingDays.Vistypeid = null;
    this.newProccessingDays.vendorid = null;
    this.newProccessingDays.processingOption = null;
    this.newProccessingDays.entriesid = null;
    this.newProccessingDays.visaFees = null;
    this.newProccessingDays.vfsFees = null;
    this.newProccessingDays.serviceCharges = null;
  }

  addvisapopup() {
    this.clearmodal();
  }
  GetAllFeeMaster(page, paginationSize,SearchKeyWord) {


    this.Searchwithid= $('#Searchwithid').val();
    this.searchtype=$('#searchtypeval').val();
    this._service.Getall_FeeMaster(page, paginationSize,SearchKeyWord,this.fk_Countryid,this.visatypeid,this.Searchwithid,this.searchtype,this.vendorid).subscribe(
      (data: any) => {
        this.FeeMasterarray = data.result;
        //console.log(this.FeeMasterarray);
        // -- for pagination
        this.totalcount = data.totalCount;
        this.totalNoofpages = Math.ceil(data.totalCount / this.paginationSize);
      },
      error => {
        this.err = error;
        this.toastr.error("Error :" + this.err);
      }
    );
  }

  // Get All Country list
  GetCountry() {
    this._visaprocessing.getCountry().subscribe(
      data => {
        this.getallCountry = { data };
        this.getallCountry = this.getallCountry.data;
      },
      error => {
        this.err = error;
        this.toastr.error("Error :" + this.err.message);
      }
    );
  }


  // Get Country Code on change on country change
  getCountry_changeonCreate = function () {
    this.CountryCode = this.newProccessingDays.fK_CountryMasterId;
    this.selectedCountryCode = this.newProccessingDays.fK_CountryMasterId;
    this.clearmodal();  // set null all dropdown 
    this.entrieslength = 0;  // Hide dropdown on change
    this.ProcessingOptionlength = 0;  // Hide dropdown on change
    if (this.CountryCode !== null) {
      this.GetCountry();
      this.getVisatypeByCountry(this.CountryCode); // Geting Visa Type
     // this.getVendorByCountry(this.CountryCode); // Geting Visa office
      this.getProcessingoption_changeonCreate(this.CountryCode); // Geting Processing Option
    } else {
      this.clearmodal();
    }
  };
  // Get Visa Type by Country Code
  getVisatypeByCountry(countryCode) {
    this.visatypeArray = [];
    if (countryCode != null) {
      this._visaprocessing._getVisaTypebyCountry(countryCode).subscribe(
        (data: any) => {
          this.visaTypeData = {};
          this.visaTypeData = data.result;
          this.visatypeArray = this.visaTypeData;
          //console.log(this.visatypeArray);
        },
        err => {
          this.toastr.error("Error :" + this.err.message);
        }
      );
    } else {
      this.clearmodal();
    }
  }


  // Get Visa office/Vendor by Country Code
  getVendorByCountry(typeId) {
    debugger;
    this.vendorArray = [];
    if (typeId != null) {
      this._visaprocessing.Get_VendorbyCountryId(this.selectedCountryCode,typeId).subscribe(
        (data: any) => {
          const tempobj = [];
          tempobj.push(data.result);
          this.vendorArray = tempobj[0];
          if (tempobj.length === 0) {
            this.newProccessingDays.vendorid = null;
          }
         // console.log(this.vendorArray);
        },
        err => {
          this.toastr.error("Error :" + this.err.message);
        }
      );
    } else {
      this.newProccessingDays.visaType = null;
      // this.newProccessingDays.no_ = null;
    }
  }

  // Get Entries on change of visa type
  getEntries_changeonCreate() {
    this.EntriesArray = [];
    if (this.newProccessingDays.Vistypeid != null) {
      this._visaprocessing.Get_EntriesbyCountryId(this.newProccessingDays.Vistypeid).subscribe(
        (data: any) => {
          const tempobj = [];
          tempobj.push(data.result);
          this.EntriesArray = tempobj[0];
          this.entrieslength = tempobj[0].length;
          //console.log(this.EntriesArray);
        },
        err => {
          this.toastr.error("Error :" + this.err.message);
        }
      );

      this.getVendorByCountry(this.newProccessingDays.Vistypeid);

    } else {
      this.clearmodal();
    }
  }

  // Get processing Option on change of Country
  getProcessingoption_changeonCreate(CountryCode) {
    this.EntriesArray = [];
    if (CountryCode != null) {
      this._visaprocessing.Get_ProcessingoptionbyCountryId(CountryCode).subscribe(
        (data: any) => {
          const tempobj = [];
          tempobj.push(data.result);
          this.ProcessingOptionArray = tempobj[0];
          this.ProcessingOptionlength = tempobj[0].length;
         console.log(this.ProcessingOptionArray);
        },
        err => {
          this.toastr.error("Error :" + this.err.message);
        }
      );
    } else {
      this.clearmodal();
    }
  }


  ProcessId(event){



   let fid= this.ProcessingOptionArray.find(x => x.processingOption === this.newProccessingDays.processingOption).id;

       
    this.Fk_ProcessOptionId=fid;
  }

  // Fee Master Creation
  CreateFeeMaster() {
    this.VisaFeeObject =
      {
        "id": 0,
        "fk_VisaTypeId": this.newProccessingDays.Vistypeid,
        "entries": this.newProccessingDays.entries,
        "processingOption": this.newProccessingDays.processingOption,
        "visaFees": this.newProccessingDays.visaFees,
        "vfsFees": this.newProccessingDays.vfsFees,
        "serviceCharges": this.newProccessingDays.serviceCharges,
        "fK_CountryMasterId": this.newProccessingDays.fK_CountryMasterId,
        "fK_VendorMasterId": this.newProccessingDays.vendorid,
        "Fk_ProcessOptionId": this.Fk_ProcessOptionId
      };

    console.log(JSON.stringify(this.VisaFeeObject));
    this._service.Create_FeeMaster(this.VisaFeeObject)
      .subscribe(
        (data: any) => {
          $('#adduserClose').click();
          this.toastr.success(data["messsage"]);
          this.newProccessingDays.fK_CountryMasterId = null;
          this.clearmodal();
          this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
        },
        error => {
          this.err = error;
          this.toastr.error('Error :' + this.err.statusText);
        }
      );
  }


  // Edit Get data by Id Branch Management
  Edit_FeesMaster(edit) {

    this.UpdateFeeMasterObj = [];
    console.info(edit);
    this.UpdateFeeMasterObj.push(edit);
  }

  // Update Visa Fee Master
  updateVisaMaster = function (VisaModel) {
    
    this.VisaFeeObject = {};
    this.VisaFeeObject =
      {
        'id': VisaModel.id,
        'visaFees': VisaModel.visaFees,
        'vfsFees': VisaModel.vfsFees,
        'serviceCharges': VisaModel.serviceCharges,
        'fK_CountryMasterId': VisaModel.countryID,
        'FK_VendorMasterId': VisaModel.vendorId,
        'IsActive':VisaModel.isActive
      };
    //console.log(JSON.stringify(this.VisaFeeObject));
    this._service.Update_FeeMaster(this.VisaFeeObject)
      .subscribe(
        (data: any) => {
          if (data.status === true) {
            this.toastr.success(data["messsage"]);
            console.info("this.searchStringcache2",this.searchStringcache);
            this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
            $('#editclose').click();
          }
        },
        error => {
          this.err = error;
          this.toastr.error('Error :' + this.err.statusText);
        });

  };

  // Delete Fee Master
  delete_feeMaster(deleteData) {
    this._service.deleteFeemaster(deleteData.id)
      .subscribe(
        data => {
          const temp = data;

          $('#btnclose1').click();
          $('#btnclose').click();
          this.toastr.success(data["messsage"]);
          this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
        },
        error => {
          this.err = error;
          this.toastr.error('Error :' + this.err.statusText);
        }
      );
  }

  deleteFeeMaster(dele) {

    this.deleteData = [];
    this.deleteData.push(dele);

  }

  //#region "--Pagination Code--"
  noofRecordstoDisplay(args: any) {
    // tslint:disable-next-line:radix
    this.paginationSize = parseInt(args.target.value);
    this.page = 1;// setting to default value
    this.pageShow = 0;
  }
  currentPageBind(currPage: any) {
    this.selectedIndex = currPage;
    this.page = currPage;
    $('ul.pagination li').removeClass('active');
    this.ngOnInit();
  }
  nextPage(nextpageNumber: number) {
    this.page = nextpageNumber + 1;
    if (this.page <= this.totalNoofpages) {
      this.pageShow = this.pageShow + 10;
    }
  }
  previousPage(prevPageNumber: number) {
    if (prevPageNumber >= 0) {
      this.page = prevPageNumber + 1;
      this.pageShow = this.pageShow - 10;
    }
  }
  //#endregion


  //#region -- search autocomplete --
  onSearch_autocomplete(values) {
    if (values !== "") {
      this._visaprocessing.CountryAutocomplete(values)
        .subscribe(
          (data: any) => {
            this.countryarray = [];
            this.countryarray.push(data.result);
            $("#countrysearch").autocomplete({   //  -------- Autocomplete populate --- 
              source: function (request, response) {
                response($.map(data.result, function (value, key) {
                  return {
                    label: value.name,
                    value: value.id,
                  };
                }));
              },
              focus: function (event, ui) {
                $('#countrysearch').val(ui.item.label);
                return false;
              },
              // Once a value in the drop down list is selected, do the following:
              select: function (event, ui) {
                // place the person.given_name value into the textfield called 'select_origin'...
                $('#countrysearch').val(ui.item.label);
                $('#selectedSearchId').val(ui.item.value);
                return false;
              },
            });
          },
          error => {
            this.err = error;
            this.toastr.error('Error :' + this.err.statusText);
          });
    }

  }
  //#endregion

  // #region --Search By country
  SearchbyCountry() {

    this.page = 1;
    this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);

    // this.searchString = $('#selectedSearchId').val();
    // this.searchStringcache= $('#selectedSearchId').val() ;

    // console.info(" this.searchStringcache1", this.searchStringcache);

    // $("#visaLoader").show();

    // if(this.searchString==""||this.searchString==null){

    //   this.toastr.error('Error : Country Not Found.');
    //   $("#visaLoader").hide();
    //   return false;
    // }

    // this.FeeMasterarray = [];
    
    // this._visaprocessing.SearchbyCountry_visaprocessing(this.searchString, this.page, this.paginationSize)
    //   .subscribe(
    //     data => {
    //       this.getFeeMaster = { data };
    //       this.FeeMasterarray = this.getFeeMaster.data.result;
    //       // -- for pagination
    //       this.totalcount = this.getFeeMaster.data.totalCount;
    //       this.totalNoofpages = Math.ceil(this.getFeeMaster.data.totalCount / this.paginationSize);
    //       $("#visaLoader").hide();
    //       $('#selectedSearchId').val("");
    //     },
    //     error => {
    //       this.err = error;
    //       this.toastr.error('Error :' + this.err.statusText);
    //       $("#visaLoader").hide();
    //     }
    //   );
  }
  // #endregion
  myFunction() {
    this.searchString = "";
    $('#countrysearch').val("");
  }
  Reload() {
    this.SearchKeyWord='';
    this.ngOnInit();
  }
  noOfRecordsToShow(event: any) {
    this.paginationSize = parseInt(event.target.value);
    this.page = 1;
    this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
  }

getvisaTypeonChange($event)
{
  $('#Searchwithid').val("0");
  $('#searchtypeval').val("");
  this.visatypeid=0;
   if($event!=null)
   {
          this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
          this.getVisatypeByCountry($event.target.value);
        
        
   }
   
}

getvisaTypesearch()
{
  $('#Searchwithid').val("0");
  $('#searchtypeval').val("");
  this.selectedCountryCode=this.fk_Countryid;
  this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
  this.getVendorByCountry(this.visatypeid);
}
getSearchAuto($event)
{
  
  this._service.getAutoSearch($event.target.value,this.fk_Countryid,this.visatypeid)
      .subscribe(
        (resp: any) => {
       this.autolist=resp.result;
       let data=this.autolist;
  
  $("#countrysearch").autocomplete({  
    minLength: 1,
    source:function (request, response) {
      response($.map(data, function (value, key) {
           return {
               label: value.name,
               value: value.name,
               this_id: value.id,
               searchtype:value.searchtype
           }
       }));
   
      },
    select: function (event, ui) {
      
      
      $('#Searchwithid').val(ui.item.this_id);
      $('#searchtypeval').val(ui.item.searchtype);
      
     
   }


  });

},
error => {
  this.err = error;
  this.toastr.error('Error :' + this.err.statusText);
});


}

getVendorSearch()
{
  
  this.GetAllFeeMaster(this.page, this.paginationSize,this.SearchKeyWord);
  
}

}


 // let visaVendorName = null;   // For Vendor name
    // if (this.visaFeeMasterObj.no_ != null) {
    //   visaVendorName = this.vendorArray.find(x => x.no_ === this.visaFeeMasterObj.no_).name;
    // }
    // let CountryId = null;    // For Country Id
    // if (this.visaFeeMasterObj.countryCode != null) {
    //   CountryId = this.getallCountry.find(x => x.countryCode === this.visaFeeMasterObj.countryCode).id;
    // }